import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';

/**
 * What a paid add-on's page shows for a facility that has not connected it.
 *
 * Marketing, camera intelligence and document signing are connected
 * services sold per facility. Their pages never look free and never look
 * broken when the facility has not got them: they say plainly that this is
 * an add-on, what it does, and where it is switched on. The left-menu link
 * itself carries no label (owner, 2026-10-25): the page says it.
 */
const AddOnPrompt = ({
  icon: Icon = Sparkles, name, summary, points = [], appKey, testId,
}) => (
  <div className="rounded-xl border border-slate-200/80 bg-white p-6 max-w-2xl"
    data-testid={testId || 'addon-prompt'}>
    <div className="flex items-center gap-3 mb-3">
      <div className="h-10 w-10 rounded-lg bg-blue-50 flex items-center justify-center">
        <Icon className="h-5 w-5 text-blue-600" />
      </div>
      <div>
        <div className="flex items-center gap-2">
          <h2 className="text-[15px] font-semibold text-slate-900">{name}</h2>
          <span className="rounded-full border border-blue-200 bg-blue-50 px-2 text-[11px] font-medium leading-[18px] text-blue-700">
            Add-on
          </span>
        </div>
        <p className="text-[12px] text-slate-500">Not yet set up for this facility</p>
      </div>
    </div>
    <p className="text-[13px] text-slate-600">{summary}</p>
    {points.length > 0 && (
      <ul className="mt-3 space-y-1.5 text-[13px] text-slate-600 list-disc pl-5">
        {points.map((p) => <li key={p}>{p}</li>)}
      </ul>
    )}
    <p className="mt-4 text-[12px] text-slate-500">
      Once your provider has set it up, connect it in Settings → Third-party
      apps and this page fills in for this facility.
    </p>
    <Link to={`/settings?tab=apps&app=${appKey}`}
      className="mt-3 inline-flex items-center px-3.5 py-2 rounded-lg bg-blue-600 text-white text-[13px] font-medium hover:bg-blue-700">
      Set it up in Third-party apps
    </Link>
  </div>
);

export default AddOnPrompt;
